<template>
  <div class="detail">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="基础信息" name="first" v-loading="loading">
        <div class="baseInfo">
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">对账单编号：</span>
              <span>{{ detailData.settNo }}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">标题：</span>
              <span>{{ detailData.title }}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">委托商：</span>
              <span>{{ detailData.companyNameNew }}</span>
              <el-tooltip v-if="detailData.companyNameOld != detailData.companyNameNew" placement="bottom" effect="light">
                <div slot="content">
                  <span style="color: #999">原委托商名称：{{ detailData.companyNameOld }}</span>
                </div>
                <i class="el-icon-warning" style="color: red; font-size: 18px; margin-right: 5px" />
              </el-tooltip>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">合计含税费用：</span>
                <span>{{ detailData.taxPrice || 0 }}元</span>
              </div>
              <div>
                <span class="span1">合计不含税费用：</span>
                <span>{{ detailData.noTaxPrice || 0 }}元</span>
              </div>
            </div>
            <!--            <div class='baseInfoContentItem specialItem'>
                          <div class='specialOne'>
                            <span class='span1'>实际含税费用：</span>
                            <span>{{ detailData.taxPrice || 0 }}元</span>
                            <el-tooltip placement='bottom' effect='light'>
                              <div slot='content'>
                                <span style='color: #999;'>基础托运费用{{ detailData.price || 0 }}元</span><br />
                                <span style='color: #999;'>基础其它费用{{ detailData.price || 0 }}元</span><br />
                                <span style='color: #FF3A30'>抵扣超出合同价对账单{{ detailData.price || 0 }}元</span><br />
                                <span style='color: #FF3A30'>暂缓开票{{ detailData.price || 0 }}元</span><br />
                              </div>
                              <i class='el-icon-warning'
                                 style='color: red;font-size: 18px;margin-right: 5px;' />
                            </el-tooltip>
                          </div>
                          <div>
                            <span class='span1'>实际不含税费用：</span>
                            <span>{{ detailData.noTaxPrice || 0 }}元</span>
                          </div>
                        </div>-->
            <div class="baseInfoContentItem">
              <span class="span1">生成对账单时间：</span>
              <span>{{ detailData.createTime }}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">台账月汇总金额：</span>
              <span>{{ detailData.statistics }}</span>
            </div>
          </div>
        </div>
        <div class="operation" v-if="detailData.isDeduct === 1">
          <div class="operationTitle">
            <div class="line" />
            <span>抵扣对账单</span>
          </div>
          <div class="operationTable">
            <el-table :data="detailData.table1" border>
              <el-table-column label="序号" align="center" type="index" />
              <el-table-column prop="settNo" label="对账单编号" align="center" />
              <el-table-column prop="settLementPrice" label="抵扣费用" align="center" />
            </el-table>
          </div>
        </div>
        <div class="baseInfo" v-if="detailData.status == 1 || detailData.status == 2">
          <div class="baseInfoTitle">
            <div class="line" />
            <span>审核信息</span>
          </div>
          <div style="width: 70%">
            <steps :step-data="stepData" :step-state="stepState" />
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line" />
            <span>操作记录</span>
          </div>
          <div class="operationTable">
            <el-table :data="detailData.operateRecordList" border>
              <el-table-column label="操作时间" align="center" width="160px">
                <div slot-scope="scope">{{ getTime(scope.row.createTime) }}</div>
              </el-table-column>
              <el-table-column prop="operateType" label="操作类型" align="center" />
              <el-table-column prop="operationName" label="操作人" align="center" />
              <el-table-column prop="remark" label="备注" align="center" />
            </el-table>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="结算费用" name="second">
        <div class="baseInfo">
          <!--          <div class='baseInfoContent' style='padding: 0'>
                      <div class='baseInfoContentItem specialItem'>
                        <div class='specialOne'>
                          <span class='span1'>合计含税结算金额：</span>
                          <span>{{ sumCost(detailData.consignorPortInfos, 'taxPrice') }}</span>
                        </div>
                        <div>
                          <span class='span1'>合计不含税结算金额：</span>
                          <span>{{ sumCost(detailData.consignorPortInfos, 'price') }}</span>
                        </div>
                      </div>
                    </div>-->
          <div class="operationTable" style="margin-top: 0">
            <!--            <div class='operationTableNav'>
                          <span>导出数据</span>
                        </div>-->
            <el-table :data="detailTable1" v-loading="detailTable1Loading" border script>
              <el-table-column prop="portName" label="作业港口" min-width="100" align="center" show-overflow-tooltip />
              <el-table-column label="作业类型" min-width="120" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ scope.row.workType === 1 ? '装船' : '卸船' }}
                </template>
              </el-table-column>
              <el-table-column prop="batchNumber" label="批次号" min-width="100" align="center" show-overflow-tooltip />
              <el-table-column prop="waybillNo" label="运单号" min-width="120" align="center" show-overflow-tooltip />
              <el-table-column prop="frameNumber" label="车架号" min-width="150" align="center" show-overflow-tooltip />
              <el-table-column prop="brandName" label="品牌" align="center" show-overflow-tooltip />
              <el-table-column prop="modelName" label="型号" align="center" show-overflow-tooltip />
              <el-table-column prop="standingBookMonth" label="台账月" min-width="100" align="center" show-overflow-tooltip />
              <el-table-column prop="taxRate" label="税率(%)" align="center" />
              <el-table-column prop="taxPrice" label="含税单价" align="center" />
              <el-table-column prop="price" label="不含税单价" align="center" />
              <el-table-column prop="taxAdjustPrice" label="含税调整金额" align="center" show-overflow-tooltip />
            </el-table>
          </div>
          <div class="paginationContainer" style="display: flex; align-items: center; padding: 10px 20px">
            <span>共{{ detailTable1Total }}条</span>
            <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="sizes,prev, pager, next,jumper" :total="detailTable1Total" @size-change="detailSizeChange" @current-change="detailCurrentChange" @prev-click="detailCurrentChange" @next-click="detailCurrentChange" />
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="其它结算费用" name="third">
        <div class="baseInfo">
          <!--          <div class='baseInfoContent' style='padding: 0'>
                      <div class='baseInfoContentItem specialItem'>
                        <div class='specialOne'>
                          <span class='span1'>合计含税结算金额：</span>
                          <span>{{ sumCost(detailData.costInfos, 'costAmount') }}</span>
                        </div>
                        <div>
                          <span class='span1'>合计不含税结算金额：</span>
                          <span>{{ sumCost(detailData.costInfos, 'excludingTaxAmount') }}</span>
                        </div>
                      </div>
                    </div>-->
          <div class="operationTable" style="margin-top: 0">
            <el-table :data="detailTable2" v-loading="detailTable2Loading" border script>
              <el-table-column label="序号" align="center" type="index" />
              <el-table-column prop="costNum" label="费用编号" align="center" />
              <el-table-column prop="costTypeName" label="费用类型" align="center" />
              <el-table-column prop="costInstruction" label="费用说明" align="center" />
              <el-table-column prop="costTime" label="费用时间" align="center">
                <template slot-scope="scope">{{ scope.row.costTime | publicFormatTime }}</template>
              </el-table-column>
              <el-table-column prop="taxRate" label="税率(%)" align="center" />
              <el-table-column prop="costAmount" label="含税价" align="center" />
              <el-table-column prop="excludingTaxAmount" label="不含税价" align="center" />
              <el-table-column prop="remark" label="说明" align="center" />
            </el-table>
          </div>
          <div class="paginationContainer" style="display: flex; align-items: center; padding: 10px 20px">
            <span>共{{ detailTable2Total }}条</span>
            <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="sizes,prev, pager, next,jumper" :total="detailTable2Total" @size-change="detail2SizeChange" @current-change="detail2CurrentChange" @prev-click="detail2CurrentChange" @next-click="detail2CurrentChange" />
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="开票信息" name="fourth" v-if="detailData.status != 0 && detailData.status != 1">
        <div class="baseInfo">
          <!--          <div class='baseInfoContent' style='padding: 0'>
                      <div class='baseInfoContentItem'>
                        <span class='span1'>是否抵扣开票：</span>
                        <span>{{ detailData.time2 }}</span>
                      </div>
                      <div class='baseInfoContentItem'>
                        <span class='span1'>抵扣开票费用编号：</span>
                        <span>{{ detailData.time2 }}</span>
                      </div>
                      <div class='baseInfoContentItem specialItem'>
                        <div class='specialOne'>
                          <span class='span1'>原开票金额：</span>
                          <span>{{ detailData.customerNatureName }}</span>
                        </div>
                        <div>
                          <span class='span1'>抵扣金额：</span>
                          <span>{{ detailData.customerScaleName }}</span>
                        </div>
                      </div>
                    </div>-->
          <div class="operationTable" style="margin-top: 0">
            <el-table :data="detailData.invoiceManageList" border script>
              <el-table-column label="序号" align="center" type="index" />
              <el-table-column prop="invoiceNo" label="发票号码" align="center" />
              <el-table-column prop="invoiceCode" label="发票代码" align="center" />
              <el-table-column prop="invoicDate" label="发票日期" align="center" />
              <el-table-column prop="taxPrice" label="含税金额" align="center" />
              <el-table-column prop="price" label="不含税金额" align="center" />
              <el-table-column prop="taxRate" label="税率" align="center" />
              <el-table-column label="开票类型" align="center">
                <template slot-scope="scope">
                  {{ scope.row.invoiceType ? '补开票' : '正常开票' }}
                </template>
              </el-table-column>
              <el-table-column prop="remake" label="备注" align="center" />
            </el-table>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="对账调整数据" name="ReconciliationAdjustment">
          <div class="baseInfo">
            <div class="operationTable" style="margin-top: 0">
              <el-table :data="reconciliationAdjustmentData" border script>
                <el-table-column prop="setType" label="结算类型" align="center" />
                <el-table-column prop="companyName" label="公司名称" align="center" />
                <el-table-column prop="batchNumber" label="批次号" align="center" />
                <el-table-column prop="waybillNo" label="运单编号" align="center" />
                <el-table-column prop="frameNumber" label="车架号" align="center" />
                <el-table-column prop="taxRate" label="税率" align="center" />
                <el-table-column prop="taxPrice" label="含税费用" align="center" />
                <el-table-column prop="taxAdjustPrice" label="对账调整费用" align="center" />
                <el-table-column prop="standingBookMonth" label="台账月" align="center" />
              </el-table>
            </div>
            <div class="paginationContainer" style="display: flex; align-items: center; padding: 10px 20px">
              <span>共{{ reconciliationAdjustmentDataTotal }}条</span>
              <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="sizes,prev, pager, next,jumper" :total="reconciliationAdjustmentDataTotal" @size-change="reconciliationAdjustmentSizeChange" @current-change="reconciliationAdjustmentCurrentChange" @prev-click="reconciliationAdjustmentCurrentChange" @next-click="reconciliationAdjustmentCurrentChange" />
            </div>
          </div>
        </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import { formatDateTime, formatTime } from '@/config/mUtils';
  import steps from '@/components/steps';
  import divBorder from '@/components/divBorder';
  import { getPageListSCFI, getPageListSOCI, pageListRA } from '@/service/getData';

  export default {
    name: 'protChargesDetail',
    components: {
      steps,
      divBorder,
    },
    props: {
      detail: {
        type: Object,
        default: {},
      },
    },
    data() {
      return {
        actNo: '',
        reconciliationAdjustmentSearchForm: {
          rows: 10,
          page: 1,
        },
        reconciliationAdjustmentData: [],
        reconciliationAdjustmentDataTotal: 0,
        loading: false,
        basicId: 0,
        activeName: 'first',
        detailData: {},
        stepData: [],
        detailTable1: [],
        detailTable1Loading: false,
        detailTable1Total: 0,
        detailTable1Size: 10,
        detailTable1Page: 1,
        detailTable2: [],
        detailTable2Loading: false,
        detailTable2Total: 0,
        detailTable2Size: 10,
        detailTable2Page: 1,
        infoInvoice: [], // 详情 开票信息
      };
    },
    computed: {
      stepState() {
        return function (state) {
          switch (state) {
            case '':
              return 'wait';
            case 'success':
              return 'success';
            case 'failure':
              return 'error';
          }
        };
      },
      getState() {
        return function (state) {
          switch (state) {
            case 0:
              return '待生效';
            case 1:
              return '生效中';
            case 2:
              return '已失效';
          }
        };
      },
      getTime() {
        return function (time) {
          return time ? formatDateTime(time, 'yyyy年mm月dd日 hh:ii:ss') : '';
        };
      },
      //合计含税结算金额
      consignorPortInfosSumTaxRate() {
        let sum = 0;
        this.detailData.consignorPortInfos
          ? this.detailData.consignorPortInfos.forEach(item => {
              sum += parseFloat(item.taxPrice);
            })
          : 0;
        return sum;
      },
      /**
       *计算合计
       * @param tableData 表格数据
       * @param field 字段名
       * @returns {function(*, *): number}
       */
      sumCost(tableData, field) {
        return function (tableData, field) {
          let sum = 0;
          tableData
            ? tableData.forEach(item => {
                sum += parseFloat(item[field]);
              })
            : 0;
          return sum;
        };
      },
    },
    filters: {},
    watch: {
      detail: {
        handler(item1, item2) {
          this.detailData = {
            ...this.detail,
            table1: [],
          };
        },
        deep: true,
      },
      activeName(val) {
        if (val === 'second') {
          this.getPageListSCFI();
        } else if (val === 'third') {
          this.getPageListSOCI();
        } else if (val === 'ReconciliationAdjustment') {
          this.getPageListRAi();
        }
      },
    },
    mounted() {
      this.detailData = {
        ...this.detail,
      };
    },
    methods: {
      reconciliationAdjustmentCurrentChange(page) {
        this.reconciliationAdjustmentSearchForm.page = page;
        this.getPageListRAi();
      },
      reconciliationAdjustmentSizeChange(rows) {
        this.reconciliationAdjustmentSearchForm.rows = rows;
        this.getPageListRAi();
      },
      async getPageListRAi() {
        const { status, message, data } = await pageListRA({ actNo: this.actNo, rows: this.reconciliationAdjustmentSearchForm.rows, page: this.reconciliationAdjustmentSearchForm.page });
        if (status !== 0) return this.$message.warning(message);
        this.reconciliationAdjustmentData = data ? data.records : [];
        this.reconciliationAdjustmentDataTotal = data ? data.total : 0;
      },
      handleClick() {
        this.$emit('tab-click-width', this.activeName);
      },
      async getPageListSCFI() {
        this.detailTable1Loading = true;
        const { status, message, data } = await getPageListSCFI({
          id: this.basicId,
          page: this.detailTable1Page,
          rows: this.detailTable1Size,
          type: 2,
        });
        this.detailTable1Loading = false;
        if (status !== 0) return this.$message.warning(message);
        this.detailTable1 = data ? data.records : [];
        this.detailTable1Total = data ? data.total : 0;
      },
      async getPageListSOCI() {
        this.detailTable2Loading = true;
        const { status, message, data } = await getPageListSOCI({
          id: this.basicId,
          page: this.detailTable2Page,
          rows: this.detailTable2Size,
        });
        this.detailTable2Loading = false;
        if (status !== 0) return this.$message.warning(message);
        this.detailTable2 = data ? data.records : [];
        this.detailTable2Total = data ? data.total : 0;
      },
      // 结算费用条数
      detailSizeChange(size) {
        this.detailTable1Size = size;
        this.getPageListSCFI();
      },
      // 结算费用页数
      detailCurrentChange(page) {
        this.detailTable1Page = page;
        this.getPageListSCFI();
      },
      // 其他结算费用条数
      detail2SizeChange(size) {
        this.detailTable2Size = size;
        this.getPageListSOCI();
      },
      // 其他结算费用页数
      detail2CurrentChange(page) {
        this.detailTable2Page = page;
        this.getPageListSOCI();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .detail {
    width: 100%;
    padding: 10px 0 20px 20px;
    max-height: 80vh;
    overflow: auto;

    ::v-deep {
      .el-table td,
      .el-table th {
        padding: 0;
      }

      .cell {
        font-size: 10px;
        padding: 0;
      }
    }

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .baseInfo {
      display: flex;
      flex-direction: column;

      &Title {
        display: flex;
        align-items: flex-end;

        p {
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }

      &Content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px 23px 0 23px;

        &Item {
          margin-bottom: 20px;

          .imgContainer {
            display: flex;
            align-items: center;
          }

          .span1 {
            font-weight: 700;
          }

          span {
            font-size: 14px;
          }

          .specialOne {
            width: 50%;
          }
        }

        .specialItem {
          display: flex;
        }
      }
    }

    .operation {
      display: flex;
      flex-direction: column;

      ::v-deep {
        .el-table .ui-warning-row {
          background-color: #fef0f0 !important;
        }

        .el-table--enable-row-hover .el-table__body tr.ui-warning-row:hover > td {
          background-color: #fef0f0 !important;
        }

        .el-table .ui-warning-row .cell {
          color: red;
        }
      }

      &Title {
        display: flex;
        align-items: flex-end;

        p {
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }

      &Table {
        width: 100%;
        margin-top: 10px;
        padding: 0 20px;

        &Nav {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-end;

          span {
            color: rgba(51, 136, 255, 1);
            text-decoration: underline;
            margin-right: 10px;

            &:hover {
              cursor: pointer;
            }
          }
        }
      }
    }
  }
</style>
